// extracted by mini-css-extract-plugin
export default {"modal-header":"styles_modal-header__N2Lwy","modal-title":"styles_modal-title__hjl+E","close-button":"styles_close-button__I6NzR"};